import { watch } from 'vue-demi';

/**
 * A utility composable for item count loaders.
 * @param {Object} state The `state` object returned by `useItemLoader`, configured with `responseToItem` returning the item count.
 * @param {Function} refresh The `refresh` function returned by `useItemLoader`.
 * @returns {Function} `refreshCount` - an alternative version of the given `refresh` function, which aims to achieve a good balance
 * between keeping the count accurate and the number of API requests small. It achieves this goal by intelligently skipping some
 * loader refreshes. Simply use it in place of the original `refresh` function within the `useRealTimeUpdate` callback.
 */
export default function useRefreshCount(state, refresh) {
  // The `refreshBuffer` allows us to limit real-time updates to a reasonable level.
  let refreshBuffer = 0;

  function resetRefreshBuffer() {
    refreshBuffer = Math.max(0, (state.item.value ?? 0) - 100) ** 0.7;
  }

  watch(state.inSync, () => {
    if (state.inSync.value) {
      resetRefreshBuffer();
    }
  });

  function refreshCount() {
    refreshBuffer -= 1;
    if (refreshBuffer < 0) {
      resetRefreshBuffer();
      refresh();
    }
  }

  return refreshCount;
}
